"use client";

import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Inquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const faqs = [{
    question: "What exterior materials do you specialize in?",
    answer: "We specialize in premium metal roofing, architectural ACM panels, James Hardie siding, LP SmartSide, stone veneer, and high-performance acrylic stucco. Our work combines lasting durability with refined, modern architectural design for high-end residential properties."
  }, {
    question: "Do you provide services outside of Calgary?",
    answer: "Yes, we proudly serve the greater Calgary area, including Airdrie, Okotoks, Cochrane, and Chestermere. Our team is equipped to handle luxury exterior projects across these regions with the same level of precision and care."
  }, {
    question: "How do I request a project estimate?",
    answer: "You can request a detailed quote by visiting our contact page and filling out the project inquiry form. Once submitted, our team will review your requirements and reach out to schedule a site assessment."
  }, {
    question: "Are your installations covered by warranty?",
    answer: "Absolutely. We stand behind our craftsmanship with comprehensive installation warranties, in addition to the manufacturer's product warranties for all materials we install, such as James Hardie or metal roofing systems."
  }, {
    question: "What makes your metal roofing superior?",
    answer: "Our metal roofing systems, including Standing Seam and Stone-Coated Steel, offer unmatched longevity, fire resistance, and energy efficiency. They are engineered to withstand the harsh Alberta climate while maintaining a sleek, modern appearance."
  }, {
    question: "Can you help with exterior design choices?",
    answer: "Yes. We work closely with homeowners to select materials, textures, and color palettes that enhance the architectural integrity of your home. Our expertise ensures your exterior renovation is both functional and visually striking."
  }, {
    question: "How long does a typical renovation take?",
    answer: "Timelines vary based on the scope of the project and the materials selected. During our initial consultation, we provide a clear project schedule so you know exactly what to expect from start to finish."
  }, {
    question: "Do you handle insurance claims?",
    answer: "We have extensive experience working with insurance providers for storm damage and exterior restoration. We can assist in documenting the necessary repairs to ensure your claim process is as smooth as possible."
  }];
  return <section data-section-id="9540" id="common-inquiries" className="bg-background text-foreground border-y border-border font-default ![padding:30px_0px_30px_0px]">
      <div className="container mx-auto px-5 md:px-14 max-w-[1320px]">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-6 transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-[120px]">
              <h2 className="font-default font-semibold text-foreground leading-[1.2] tracking-tight text-[clamp(2rem,4vw,3.25rem)]">
                <span className="">FAQ</span>
                <span aria-hidden="true" className="inline-block align-baseline ml-[0.15em] bg-primary !text-sm" style={{
                width: "0.7em",
                height: "0.7em"
              }} />
              </h2>

              <p className="mt-8 text-foreground text-[clamp(1.125rem,1.2vw,1.25rem)] leading-[1.6] font-normal max-w-md">
                If your specific question isn't addressed here, please reach out through our contact form.
              </p>

              <div className="mt-6">
                <Link to="/ContactPage" className="group inline-flex items-center text-foreground font-medium relative w-fit">
                  <span className="relative">
                    Contact our team &rarr;
                    <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-primary transition-[width] duration-[220ms] ease-out group-hover:w-full" />
                  </span>
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, i) => <AccordionItem data-index={i} key={i} value={`item-${i}`} className="border-0 border-b border-border last:border-b-0">
                  <AccordionTrigger className="py-7 text-left text-foreground font-default font-semibold hover:no-underline text-[clamp(1.125rem,1.4vw,1.375rem)] leading-[1.2] tracking-tight rounded-md [&>svg]:hidden group items-center">
                    <span className="flex-1 pr-6">{faq.question}</span>
                    <span aria-hidden="true" className="relative shrink-0 w-6 h-6 transition-transform duration-200 ease-out group-data-[state=open]:rotate-45">
                      <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-[2px] bg-foreground" />
                      <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[2px] h-6 bg-foreground" />
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-7 pt-0 pr-6">
                    <p className="text-foreground text-base leading-[1.6] font-normal max-w-2xl">
                      {faq.answer}
                    </p>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}